import growl from '../../ui/growl'

export const MANGO_FILTER_KEY = 'mangoFilter'

export const mangoFilterTransform = (values) => {
    if(!values) return values
    const mangoFilters = values[MANGO_FILTER_KEY] //|| undefined
    if (mangoFilters) {
      delete values[MANGO_FILTER_KEY]
      
      try {
        // Ensure we have a proper object string (add braces if not present)
        let jsonString = mangoFilters.trim().startsWith('{') ? mangoFilters : `{${mangoFilters}}`
        
        // Add quotes around property names to convert JS object notation to valid JSON
        jsonString = jsonString.replace(/([{,]\s*)([a-zA-Z_$][a-zA-Z0-9_$]*)\s*:/g, '$1"$2":')
        
        const parsed = JSON.parse(jsonString)
        values = {...values, ...parsed}
      } catch (error) {
        console.error("Failed to parse mangoFilters:", mangoFilters, error)
        growl.error(`Invalid filter format: ${mangoFilters}`, 'Filter Parse Error')
        // Return values without the mango filters if parsing fails
      }
    }

    return values
  }